@use "../../styles/breakpoint.module.scss" as *;

.inner {
    composes: safeGridContainer from "../../styles/composable/layout.module.css";
}

.heading {
    grid-column: 1 / -1;
    margin-bottom: var(--spacer-40);
    font: var(--font-h-48);
    text-align: center;
}

.list {
    grid-column: 2 / span 10;
    border-top: 1px solid var(--color-contrast);

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.featuresList,
.accessoryList,
.dimensions,
.warrantyList {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: grid;
    gap: var(--spacer-16);
    color: var(--gray-900);
    font: var(--font-button-16);
}

.warrantyList a {
    font: var(--font-text-link-14);
    color: inherit;
    text-decoration: underline;
}

.checkmarkItem {
    display: flex;
    align-items: flex-start;
    gap: var(--spacer-16);
}

.check {
    width: 14px;
    height: 12px;
    margin-top: 4px;
    flex-shrink: 0;
    fill: var(--pecan);
}

.dimensionRow {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacer-4) var(--spacer-16);
}

.dimensionLabel {
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--gray-700);
}

.accessoryGroups {
    composes: grid from "../../styles/composable/layout.module.css";
}

.accessoryGroup {
    grid-column: span 6;

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.accessoryHeading {
    margin-bottom: var(--spacer-16);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--gray-700);
}
